export const layout = {
  maxContentWidth: '1100px',
  headerHeight: '80px',
  mobileHeaderHeight: '56px',
  logoHeight: '40px',
  logoMobileHeight: '32px',
  gap: '20px',
}
